import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import React from 'react'

interface Photo {
  document_title: string
  public_path: string
}

interface CarouselProps {
  photos: Photo[]
}

const Carousel: React.FC<CarouselProps> = ({ photos }) => {
  return (
    <div className='objectDetails__carousel'>
      <Swiper
        grabCursor
        speed={1000}
        centeredSlides
        slideToClickedSlide
        touchMoveStopPropagation
        modules={[Autoplay]}
        preventClicks={true}
        slidesPerView='auto'
        autoplay={{ delay: 5000 }}>
        {photos.map((photo, idx) => <SwiperSlide
          key={idx}
          className='photo__slide'>
          <img
            alt={photo.document_title}
            src={photo.public_path}
          />
        </SwiperSlide>)}
      </Swiper>
    </div>
  )
}

export default Carousel